/**
 * Created by sagardesai on 10/07/18.
 */

export const FOLLOWERS_LIST_REQUEST = "FOLLOWERS_LIST_REQUEST";
export const FOLLOWERS_LIST_RECEIVE = "FOLLOWERS_LIST_RECEIVE";
export const FOLLOWERS_LIST_FAILURE = "FOLLOWERS_LIST_FAILURE";
export const RESET_FOLLOWERS_LIST = "RESET_FOLLOWERS_LIST";
export const SET_SEARCH_FOLLOWERS_STATE = "SET_SEARCH_FOLLOWERS_STATE";